import React, { useEffect, useState } from 'react'
import { Container, Row, Col, Card, Form, ButtonGroup, Button, Modal } from 'react-bootstrap'
import PageTitle from '../components/common/PageTitle'
import api from '../api/api'
import { useTranslation } from 'react-i18next';

import swal from 'sweetalert';
import { useNavigate } from 'react-router';
import './AdminManagement.css';

const CommandeManagement = () => {

    const { t } = useTranslation();
    const [toggle, setToggle] = useState(false)

    const navigate = useNavigate()

    const [userUid, setUserUid] = useState('')

    const [SingleEquipment, setSingleEquipment] = useState([]);
    const [equipments, setEquipments] = useState([])
    const [code, setCode] = useState('')
    const [SearchCode, setSearchCode] = useState('')

    const [existUsers, setExistUsers] = useState([])
    const [users, setUsers] = useState([])

    const getAllEquipments = async () => {
        await api.get('/admin/all-equipments')
            .then(response => {
                let equipmentsData = response.data.equipments
                setEquipments(equipmentsData)
            }).catch(err => {
                console.error(err)
            })
    }

    useEffect(() => {
        getUsersList()
        getAllEquipments()
    }, [])

    const getUsersList = async () => {
        await api.get("/admin/users")
            .then(response => {
                let usersData = response.data.users
                setUsers(usersData)
            }).catch(err => {
                console.error(err)
            })
    }
    const getExistUsers = async () => {
        await api.get('/admin/exist-users')
            .then(response => {
                var Data = response.data.users
                setExistUsers(Data)
            }).catch(err => {
                console.error(err)
            })
    }
    const getSingleEquipment = async (equipmentUid, type) => {

        let data = {
            equipment_uid: equipmentUid,
        }

        await api.post('/equipment/single-equipment', data)
            .then(response => {
                let equips = response.data.equipments;
                if (response.data.type === "success") {
                    setSingleEquipment(equips)
                    setCode(equips.code)
                    existUsers.map(user => {
                        if (user.id === equips.user_id) {
                            setUserUid(user.uid)
                        }
                    })
                }
            }).catch(err => {
                console.error(err)
            })

        setToggle(!toggle)
        if (type === 'USER') {
            getExistUsers()
        }
    }

    const assignEquipmentToUser = (userUid) => {
        let data = {
            code: code,
            user_uid: userUid,
        }
        api.post('/admin/assign-equipment', data)
            .then(response => {
                if (response.data.type === 'success') {
                    swal(`${t('Equipment_updated')}`, {
                        icon: "success",
                    });
                    setToggle(false)
                    resetForm()
                    getAllEquipments()
                }
                if (response.data.type === 'danger') {
                    swal({
                        icon: 'error',
                        title: t('Oops...'),
                        text: t('error')
                    })
                    resetForm()
                }
            }).catch(err => {
                swal({
                    icon: 'error',
                    title: t('Oops...'),
                    text: t('error')
                })
            })
    }


    const resetForm = () => {
        setCode('');
        setUserUid('')
    }

    const filteredEquips = equipments.filter(equip => {
        if (SearchCode !== '') {
            return (
                equip.code.toLowerCase().includes(SearchCode.toLowerCase())
            )
        }
        return equip
    })
    return (
        <>
            <Container className="admin-management-page">
                <Row noGutters className="page-header admin-management-heading">
                    <PageTitle
                        title={t('commande_manag')}
                        sm="4"
                        className="text-sm-left"
                    />
                </Row>
                <section className="admin-management-toolbar">
                    <div className="admin-management-toolbar-title"><i className="fas fa-search" aria-hidden="true" />{t('search_commande')}</div>
                <Row form className="admin-management-filters">
                    <Col className="form-group">
                        <Form.Group>
                            <div className="d-flex">
                                <Form.Control
                                    value={SearchCode}
                                    onChange={(e) => { setSearchCode(e.target.value) }}
                                    id="search"
                                    placeholder={t('search_by_code')} />

                            </div>
                        </Form.Group>
                    </Col>
                </Row>
                </section>
                <section className="admin-management-toolbar">
                    <div className="admin-management-toolbar-title"><i className="fas fa-bolt" aria-hidden="true" />{t('my_actions')}</div>
                <Row form>
                    <ButtonGroup className="admin-management-actions">
                        <Button variant="outline-primary" onClick={() => navigate('/admin/add-equipment')}>{t('add_commands')} </Button>
                    </ButtonGroup>

                </Row>
                </section>
                <Card className="admin-data-card" style={{overflow:"auto"}}>
                    <table className="table mb-0 text-center" >
                        <thead className="bg-light">
                            <tr>
                                <th scope="col" className="border-0">{t('code')}</th>
                                <th scope="col" className="border-0">{t('item')}</th>
                                <th scope="col" className="border-0">{t('user')}</th>
                                <th scope="col" className="border-0"></th>
                                <th scope="col" className="border-0"></th>
                            </tr>
                        </thead>
                        <tbody>
                            {filteredEquips.length === 0 && (
                                <tr>
                                    <td colSpan="6" className="admin-empty-row">{t('no_data_available')}</td>
                                </tr>
                            )}
                            {
                                filteredEquips.map(item => {
                                    let nameUser = ''
                                    users.map(user => {
                                        if (user.id === item.user_id) {
                                            nameUser = user.name
                                        }
                                    })
                                    return (
                                        <tr key={item.uid || item.id}>
                                            <td>{item.code}</td>
                                            <td>{item.id}</td>
                                            <td>{nameUser}</td>
                                            <td>
                                                {
                                                    item.deleted_at === null
                                                        ?
                                                        <ButtonGroup size="sm" className="mr-2">
                                                            <Button title={t('feature_not_available')} disabled><i className="material-icons">&#xe3c9;</i></Button>
                                                            <Button title={t('feature_not_available')} disabled variant="danger"><i className="material-icons">&#xe872;</i></Button>
                                                        </ButtonGroup>
                                                        :
                                                        null
                                                }

                                            </td>
                                            {
                                                item.deleted_at === null
                                                    ?
                                                    <td>
                                                        <ButtonGroup size="sm" className="mr-2">
                                                            <Button variant="outline-primary" onClick={() => { getSingleEquipment(item.uid, 'USER') }}>{t('Assign_to_user')}</Button>
                                                        </ButtonGroup>

                                                    </td>

                                                    :
                                                    null
                                            }
                                            <td></td>

                                        </tr>

                                    )
                                })
                            }

                        </tbody>
                    </table>

                </Card>

            </Container>
            <Modal centered={true} show={toggle} onHide={() => setToggle(false)} dialogClassName="admin-management-modal">
                <Modal.Header closeButton>
                    <Modal.Title>{t('Assign_to_user')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row className='d-flex justify-content-center'>
                        <Col lg='6' md='8' sm='8'>
                            <Form.Group>
                                <Form.Select
                                    id="users"
                                    value={userUid}
                                    onChange={(e) => { setUserUid(e.target.value) }}
                                >
                                    <option value="">{t("Select_User")}</option>

                                    {
                                        existUsers.map(user => {
                                            return <option key={user.uid} value={user.uid}>{user.name}</option>

                                        })
                                    }
                                </Form.Select>

                            </Form.Group>
                        </Col>
                    </Row>


                </Modal.Body>
                <Modal.Footer>
                    <Button variant="outline-secondary" onClick={() => { resetForm(); setToggle(false) }}>
                        <i className="fa fa-times mr-2" aria-hidden="true" />
                        {t('cancel')}
                    </Button>
                    <Button onClick={() => assignEquipmentToUser(userUid)}>
                        <i className="fa fa-check mr-2" aria-hidden="true" />
                        {t('save')}
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default CommandeManagement
